import { styled } from '@mui/material';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';

const HeroSection = styled('section')(() => ({
  background: 'url("https://bucket.ywhdev.com/wl/?id=wtFInrMLAiL6JZmuqOAwUkgLygYvCsec&fmode=open")',
  overflow: 'hidden',
  height: 700,
  alignItems: 'flex-end',
  display: 'flex',
  justifyContent: 'center',
  paddingBottom: 80,
  position: 'relative',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  borderBottom: '8px solid #5284e0',
  gap: 8,
  textAlign: 'center',
  '& div.header': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    h1: {
      color: 'white',
      fontFamily: 'Playfair Display',
      zIndex: 2,
      fontSize: 48,
      lineHeight: '60px',
      fontWeight: 700,
    },
    h3: {
      color: '#CDA07D',
      zIndex: 2,
      fontSize: 24,
      lineHeight: '36px',
      fontWeight: 600,
    },
    img: {
      width: '100%',
      bottom: 0,
      position: 'absolute',
    },
  },
}));

const Content = styled('section')(({ theme }) => ({
  padding: '64px 0 0 0',
}));

const PricingYourHome = () => {
  return (
    <>
      <HeroSection>
        <div className="header">
          <h1>Pricing Your Home</h1>
          <h3>Pricing your home is both an art and a science</h3>
        </div>
      </HeroSection>
      <Content>
        <Section1 />
        <Section2 />
        <Section3 />
        <Section4 />
      </Content>
    </>
  );
};

export default PricingYourHome;
